var systemConfig = {
  userManagement: {
    passwordExpiryDays: 30
  },
  searchRedirect: false,
  transactionLockText: 'You have pending payments. You will not be allowed to create quotes, proposals or make any kind of payments.'
};

export { systemConfig as s };
